export default {
    generateCourseFile: '/courseFile/generate',
}
